/* unplugin-vue-components disabled */import script from "./CourseDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./CourseDetail.vue?vue&type=script&lang=ts&setup=true"

import "./CourseDetail.vue?vue&type=style&index=0&id=54cdd040&scoped=true&lang=css"
import "./CourseDetail.vue?vue&type=style&index=1&id=54cdd040&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54cdd040"]])

export default __exports__